import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import PromotionViewPage from "./pages/PromotionViewPage.vue";
import PromotionCreatePage from "./pages/PromotionCreatePage.vue";
import PromotionDetailPage from "./pages/PromotionDetailPage.vue";
import PromotionCheckPage from "./pages/PromotionCheckPage.vue";
import PromotionUpdatePage from "./pages/PromotionUpdatePage.vue";

export const PromotionRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "promotion"
) => [
  {
    name: "PromotionViewPage",
    path: prefix,
    component: PromotionViewPage,
    meta: { title: "Promotion List" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.PROMOTION_VIEW
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "PromotionCreatePage",
    path: `${prefix}/create`,
    component: PromotionCreatePage,
    meta: { title: "Create New Promotion" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.PROMOTION_CREATE
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "PromotionCheckPage",
    path: `${prefix}/check`,
    component: PromotionCheckPage,
    meta: { title: "Check Promotion" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.PROMOTION_VIEW
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "PromotionDetailPage",
    path: `${prefix}/:id`,
    component: PromotionDetailPage,
    meta: { title: "View Promotion" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.PROMOTION_VIEW
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "PromotionUpdatePage",
    path: `${prefix}/edit/:id`,
    component: PromotionUpdatePage,
    meta: { title: "Update Promotion" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.PROMOTION_EDIT
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
